import { Component, OnInit } from '@angular/core';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { NavController, Platform, MenuController } from '@ionic/angular';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';


@Component({
  selector: 'app-vasfaq',
  templateUrl: './vasfaq.page.html',
  styleUrls: ['./vasfaq.page.scss'],
})
export class VasfaqPage implements OnInit {
  FaqsJson: any;
  collapseList: any;
  request: any;
  langcontext: any;
  headingtitle: any;
  label: any;
  response: any;
  selectidx: any;


  constructor(public platform: Platform,public cmndef: CommonDefinitionService,public menuCtrl: MenuController, public cmndecl: CommonDeclarationService, public api: RestapiService, public inappbrowser: InAppBrowser, public navctrl: NavController) {
    this.FaqsJson = [];
    this.request={};
    this.platform.ready().then(()=>{
      if (this.cmndecl.LanguageJson) {
        this.langcontext = this.cmndecl.LanguageJson.pages[0]['vas_faq'];
      } else {
        this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
        this.langcontext = this.cmndecl.LanguageJson['pages'][0].vas_faq;
      }
      this.headingtitle = this.langcontext.heading.text;
      this.label = this.langcontext.heading.label;
      this.FaqsJson = this.langcontext.queries;
      console.log(this.FaqsJson);
      // this.api.postapi("getFAQList",this.request).then(res=>{
      //   console.log(res);
      //   this.response  = res;
      //   this.FaqsJson = this.response.faqs;
      //   console.log(JSON.stringify(this.FaqsJson));
      // },err=>{
      //   console.log(err);
      // })
    });
  }

  ionViewWillEnter () {
    this.menuCtrl.swipeEnable(false);
  }

  ngOnInit() {
    var baseurl = "https://www.pnbmetlife.com/customer-service/customer-health-initiative.html";
    let browser = this.inappbrowser.create(baseurl, "_blank");
    browser.on('exit').subscribe(() => {
      this.navctrl.navigateRoot("/va/chat");
    }, err => {
      console.error(err);
    });
  }
  
  showresponse(idx){
    console.log(idx);
    if(this.selectidx == idx)
      this.selectidx = 99999999;
    else
      this.selectidx = idx;
  }
}
